import BillsBody1 from './BillsBody1'

export const BillsBodies = {
  BillsBody1,
}
